import React,{useState} from 'react'
import CV from "../images/cv.pdf"
import { Link, animateScroll as scroll } from "react-scroll";
import {VscThreeBars} from "react-icons/vsc"
import {AiFillCloseCircle} from "react-icons/ai"
const Header = () => {
  const [header,setHeader] = useState(false)
  const headerArray = [
      {id:1,numero:"01.",titulo:"About me",url:"acerca"},
      {id:2,numero:"02.",titulo:"Skills",url:"habilidades"},
      {id:3,numero:"03.",titulo:"Works",url:"trabajos"},
      {id:4,numero:"04.",titulo:"Contact",url:"contactame"},

  ]
  return (
    <div className='flex bg-slate-800 w-full  h-full sm:h-20'>
        
        <div className='justify-end hidden sm:flex mr-8 text-gray-300 text-xs sm:text-sm   w-full'>
            {headerArray.map((head => (
                <div key={head.id} className="flex ">
                <Link
                  className="flex  mt-10"
                  activeClass="active"
                  to={`${head.url}`}
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                >
                  <h4 className="text-emerald-300 ">{head.numero}</h4>
                  <h1 className="ml-0.5 mr-2  text-gray-300 hover:text-emerald-300 hover:cursor-pointer">
                    {head.titulo}
                  </h1>
                </Link>
              </div>

            )))}
            <a href={CV} target="_blank" smooth={true} download='CV-Yeremi.pdf' className='border justify-center  items-center h-10 mt-8 mr-2 flex rounded hover:bg-emerald-900   border-emerald-300  ml-4 px-4'>
                <h1 className='text-emerald-300   '>Resume</h1>
            </a>
        </div>
        <div className='sm:hidden justify-end flex  w-full '>
           {header ? (<div className='w-full h-full   bg-slate-700'>
           {headerArray.map((head => (
               <div className="justify-center flex " key={head.id}>
        
                
               <Link
                 
                 className="flex w-1/3 mt-10"
                 activeClass="active"
                 to={`${head.url}`}
                 spy={true}
                 smooth={true}
                 offset={-70}
                 duration={500}
               >
                 <h4 className="text-emerald-300 ">{head.numero}</h4>
                 <h1 className="ml-0.5 mr-2 font-bold text-gray-300 hover:text-emerald-300 hover:cursor-pointer">
                   {head.titulo}
                 </h1>
               </Link>
             
           </div>
               
           )))}
            <a href={CV} target="_blank" smooth={true} download='CV-Yeremi.pdf' className='border justify-center   items-center h-10 mt-8 mr-2 flex rounded hover:bg-emerald-900   border-emerald-300  ml-4 px-4'>
                <h1 className='text-emerald-300   '>Resume</h1>
            </a>

           <div className='w-full py-4  justify-center   flex'>
           <button onClick={() => setHeader(false)}><AiFillCloseCircle className=' w-full px-2 h-full text-gray-300 mr-4 text-3xl'/></button>
           </div>
           
           </div>) : ( <button onClick={() => setHeader(true)}><VscThreeBars className='text-gray-300 mr-4 mt-4 text-3xl'/></button>)}
        </div>
    </div>
  )
}

export default Header